module.exports = __webpack_public_path__ + "static/img/titlt_logo.5d479df5.png";